/* AKKURANDO 2.0 – Hauptnavigation (Desktop-Panels + Handy-Menü). Markup: snippets/akk-nav.liquid, akk-nav-mobile.liquid.
   Regeln: Maus – Zeigen öffnet nach kurzer Verzögerung (kein versehentliches Aufklappen beim Überfahren), Wechsel zwischen
   offenen Panels sofort, Verlassen schließt mit Nachlauf. Touch/Stift – erster Tipp öffnet, Navigation über „Alle …“.
   Tastatur – Schalter öffnet/schließt, Pfeil runter springt ins Panel, Pfeile bewegen, Escape schließt und gibt Fokus zurück.
   Klick neben das Panel schließt nur (löst nichts auf der Seite aus). Scrollen oder schmaler Bildschirm schließt. */
(function () {
  'use strict';
  var lastPointer = 'mouse';
  document.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; }, true);
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function samePageHash(a) {
    return a && a.hash && a.hostname === location.hostname && a.pathname === location.pathname;
  }

  /* ---------------- Desktop ---------------- */
  function desktop(nav) {
    var header = nav.closest('header') || nav.parentElement;
    var wrap = nav.parentElement.querySelector('[data-akn-panels]');
    if (!header || !wrap) return;
    header.appendChild(wrap); /* Panels an der Header-Kante ausrichten, nicht an der Menüspalte */
    var items = Array.prototype.slice.call(nav.querySelectorAll('.akn-i'));
    var cur = null, tOpen = 0, tClose = 0, scrollAt = 0;
    var scrim = document.createElement('div');
    scrim.className = 'akn-scrim';
    scrim.setAttribute('aria-hidden', 'true');
    /* in die Header-Section: deren Stapelebene liegt über dem Seiteninhalt, der Header (z-20) über der Abdunklung */
    var sec = header.closest('.shopify-section') || header.parentElement;
    sec.insertBefore(scrim, sec.firstChild);

    function ctl(li) { return li.querySelector('[aria-controls]'); }
    function panel(li) { return li && li.dataset.aknI ? document.getElementById(li.dataset.aknI) : null; }
    function focusables(p) { return Array.prototype.slice.call(p.querySelectorAll('a[href],button:not([disabled])')); }
    function place() {
      var r = header.getBoundingClientRect();
      document.documentElement.style.setProperty('--akn-top', Math.max(0, Math.round(r.bottom)) + 'px');
    }
    function open(li, focusFirst) {
      clearTimeout(tOpen); clearTimeout(tClose);
      var p = panel(li); if (!p) return;
      if (cur !== li) {
        var switching = !!cur;
        if (switching) { wrap.classList.add('is-switch'); close(); }
        cur = li; place();
        p.removeAttribute('inert'); p.classList.add('is-open'); li.classList.add('is-open');
        ctl(li).setAttribute('aria-expanded', 'true');
        scrim.classList.add('is-on');
        scrollAt = window.scrollY;
        if (switching) requestAnimationFrame(function () { requestAnimationFrame(function () { wrap.classList.remove('is-switch'); }); });
      }
      if (focusFirst) { var f = focusables(p)[0]; if (f) f.focus({ preventScroll: true }); }
    }
    function close(refocus) {
      clearTimeout(tOpen); clearTimeout(tClose);
      if (!cur) return;
      var li = cur, p = panel(li); cur = null;
      p.classList.remove('is-open'); p.setAttribute('inert', ''); li.classList.remove('is-open');
      ctl(li).setAttribute('aria-expanded', 'false');
      scrim.classList.remove('is-on');
      if (refocus) ctl(li).focus({ preventScroll: true });
    }
    function laterClose(ms) { clearTimeout(tClose); tClose = setTimeout(function () { close(); }, ms); }

    items.forEach(function (li) {
      var hasPanel = !!li.dataset.aknI;
      li.addEventListener('pointerenter', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        clearTimeout(tClose); clearTimeout(tOpen);
        if (!hasPanel) { if (cur) laterClose(160); return; }
        if (cur === li) return;
        tOpen = setTimeout(function () { open(li); }, cur ? 80 : 150);
      });
      li.addEventListener('pointerleave', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        clearTimeout(tOpen);
        if (cur) laterClose(280);
      });
      if (!hasPanel) return;
      var c = ctl(li), label = li.querySelector('[data-akn-label]');
      c.addEventListener('click', function (e) {
        e.preventDefault();
        if (cur === li) close(); else open(li);
      });
      if (label) label.addEventListener('click', function (e) {
        if (lastPointer === 'mouse' && e.detail !== 0) return; /* Maus: Name führt zur Kategorie */
        if (e.detail === 0) return; /* Tastatur-Enter: zur Kategorie */
        e.preventDefault(); /* Touch: erster Tipp öffnet */
        if (cur === li) close(); else open(li);
      });
      [c, label].forEach(function (el) {
        if (el) el.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown') { e.preventDefault(); open(li, true); }
          /* Tab vom offenen Schalter führt ins Panel (Panels liegen im DOM am Header-Ende) */
          else if (e.key === 'Tab' && !e.shiftKey && cur === li && el === c) { e.preventDefault(); open(li, true); }
        });
      });
    });

    Array.prototype.forEach.call(wrap.querySelectorAll('.akn-p'), function (p) {
      p.addEventListener('pointerenter', function (e) { if (!e.pointerType || e.pointerType === 'mouse') { clearTimeout(tClose); clearTimeout(tOpen); } });
      p.addEventListener('pointerleave', function (e) { if ((!e.pointerType || e.pointerType === 'mouse') && cur) laterClose(280); });
      p.addEventListener('keydown', function (e) {
        var list = focusables(p), i = list.indexOf(document.activeElement);
        if (e.key === 'Tab' && cur) {
          var from = cur;
          if (e.shiftKey && i === 0) { e.preventDefault(); ctl(from).focus(); }
          else if (!e.shiftKey && i === list.length - 1) {
            e.preventDefault();
            var next = items[items.indexOf(from) + 1];
            close();
            var t = next ? next.querySelector('a,button') : null;
            if (t) t.focus(); else ctl(from).focus();
          }
          return;
        }
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        if (i < 0) return;
        e.preventDefault();
        var n = list[i + (e.key === 'ArrowDown' ? 1 : -1)];
        if (n) n.focus(); else if (e.key === 'ArrowUp' && cur) ctl(cur).focus();
      });
      p.addEventListener('click', function (e) {
        var a = e.target.closest('a[href]');
        if (!a) return;
        if (samePageHash(a)) { close(); }
        else setTimeout(function () { close(); }, 0);
      });
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && cur) { e.stopPropagation(); close(true); } }, true);
    document.addEventListener('focusin', function (e) {
      if (cur && !nav.contains(e.target) && !wrap.contains(e.target)) close();
    });
    document.addEventListener('pointerdown', function (e) {
      if (cur && !header.contains(e.target)) close();
    }, true);
    scrim.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); close(); });
    window.addEventListener('scroll', function () { if (cur && Math.abs(window.scrollY - scrollAt) > 80) close(); }, { passive: true });
    window.addEventListener('resize', function () { if (window.innerWidth < 1024) close(); else if (cur) place(); });
    window.addEventListener('pagehide', function () { close(); });
  }

  /* ---------------- Handy ---------------- */
  function mobile(root) {
    var drawer = root.closest('menu-drawer') || document.getElementById('MenuDrawer');
    var stage = root.querySelector('[data-akd-stage]');
    var views = Array.prototype.slice.call(root.querySelectorAll('[data-akd-view]'));
    var home = views[0], active = null;

    function go(btn) {
      var v = document.getElementById(btn.getAttribute('aria-controls'));
      if (!v) return;
      active = v;
      v.scrollTop = 0;
      v.removeAttribute('inert'); v.classList.add('is-active');
      home.classList.add('is-behind'); home.setAttribute('inert', '');
      btn.setAttribute('aria-expanded', 'true');
      setTimeout(function () { var b = v.querySelector('[data-akd-back]'); if (b) b.focus({ preventScroll: true }); }, reduced ? 0 : 60);
    }
    function back() {
      if (!active) return;
      var v = active, btn = root.querySelector('[aria-controls="' + v.id + '"]');
      active = null;
      v.classList.remove('is-active'); v.setAttribute('inert', '');
      home.classList.remove('is-behind'); home.removeAttribute('inert');
      if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus({ preventScroll: true }); }
    }
    function reset() {
      views.forEach(function (v, i) { if (i) { v.classList.remove('is-active'); v.setAttribute('inert', ''); } });
      home.classList.remove('is-behind'); home.removeAttribute('inert'); home.scrollTop = 0;
      Array.prototype.forEach.call(root.querySelectorAll('[data-akd-go]'), function (b) { b.setAttribute('aria-expanded', 'false'); });
      active = null;
    }
    function hide() { if (drawer && typeof drawer.hide === 'function') drawer.hide(); }

    root.addEventListener('click', function (e) {
      var g = e.target.closest('[data-akd-go]'); if (g) { e.preventDefault(); go(g); return; }
      if (e.target.closest('[data-akd-back]')) { e.preventDefault(); back(); return; }
      if (e.target.closest('[data-akd-close]')) { e.preventDefault(); hide(); return; }
      var a = e.target.closest('a[href]');
      /* #messen öffnet das Maßband auch auf anderen Seiten, wenn es dort eingebunden ist (z. B. Produktseite) */
      if (a && (samePageHash(a) || (a.hash === '#messen' && document.querySelector('[data-akm]')))) {
        /* z. B. Batteriefinder auf der Startseite: Schublade sperrt das Scrollen – erst schließen, dann springen.
           #messen öffnet das Maßband selbst (assets/akk-measure.js). */
        if (a.hash !== '#messen') {
          e.preventDefault();
          var target = document.getElementById(a.hash.slice(1)), done = false;
          var jump = function () {
            if (done) return; done = true;
            requestAnimationFrame(function () {
              if (target) target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
              if (history.replaceState) history.replaceState(null, '', a.hash);
            });
          };
          /* erst springen, wenn die Schublade zu ist und die Scroll-Sperre aufgehoben wurde */
          if (drawer) drawer.addEventListener('drawer:afterHide', jump, { once: true });
          setTimeout(jump, 1200);
        }
        hide();
      }
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && active) { e.stopPropagation(); back(); }
    });
    if (drawer) drawer.addEventListener('drawer:afterHide', reset);

    /* Wischen nach rechts = zurück (nur in der zweiten Ebene, nur klar waagerecht) */
    var sx = 0, sy = 0, tracking = false;
    stage.addEventListener('touchstart', function (e) {
      if (!active || e.touches.length !== 1) return;
      tracking = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (!tracking) return; tracking = false;
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = Math.abs(t.clientY - sy);
      if (dx > 70 && dy < 40 && !e.target.closest('.akn-chips')) back();
    }, { passive: true });
  }

  function init() {
    var nav = document.querySelector('[data-akn]');
    if (nav && !nav.dataset.ready) { nav.dataset.ready = '1'; desktop(nav); }
    var d = document.querySelector('[data-akd]');
    if (d && !d.dataset.ready) { d.dataset.ready = '1'; mobile(d); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
